import { Config, Context, Effect, Layer, pipe } from "effect";
import { decodeBase64String } from "effect/Encoding";
import { SecretUnsealerError } from "./SecretUnsealerErrors";
const make = (config)=>Effect.gen(function*() {
        const { unsealingKeys } = config;
        return {
            getPrivateKeyById: (id)=>Effect.gen(function*() {
                    const key = unsealingKeys.find((key)=>key.keyId === id);
                    if (!key) {
                        return yield* Effect.fail(new SecretUnsealerError("SecretKeyNotFound", new Error(`Secret key not found for id: ${id}`)));
                    }
                    return key;
                })
        };
    });
/**
 * A Secret Unsealer Private Key Provider that is backed by a static list of keys
 *
 * We could also implement this via a database or something
 */ export class SecretUnsealerPrivateKeyProvider extends Context.Tag("@open-revenue/utils/SecretUnsealerPrivateKeyProvider/SecretUnsealerPrivateKeyProvider")() {
    static staticDefaultEncoded = pipe(Config.unwrap(Config.string("SECRET_UNSEALER_PRIVATE_KEY")), Effect.tap((str)=>Effect.log(`str: ${str}`)), Effect.flatMap((str)=>{
        return decodeBase64String(str).pipe(Effect.map((decoded)=>JSON.parse(decoded)));
    }), Effect.flatMap((x)=>make({
            unsealingKeys: [
                x
            ]
        })), Layer.effect(this));
    static staticLayer = (config)=>pipe(make(config), Layer.effect(this));
    static makeEncoded = (config)=>pipe(decodeBase64String(config.encodedUnsealingKeys).pipe(Effect.map((decoded)=>JSON.parse(decoded))), Effect.flatMap(make), Layer.effect(this));
    static staticLayerEncoded = (config)=>pipe(decodeBase64String(config.encodedUnsealingKeys).pipe(Effect.map((decoded)=>JSON.parse(decoded))), Effect.flatMap(make), Layer.effect(this));
    static staticLayerConfig = (config)=>pipe(Config.unwrap(config), Effect.flatMap(make), Layer.effect(this));
    static staticLayerConfigEncoded = (config)=>pipe(Config.unwrap(config), Config.map(({ encodedUnsealingKeys })=>({
                unsealingKeys: encodedUnsealingKeys.split(",").map((y)=>JSON.parse(Effect.runSync(decodeBase64String(y))))
            })), Effect.flatMap(make), Layer.effect(this));
}
